import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import './statusprogres.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import CoinsPopup from './CoinsPopup';
import HeartPopup from './HeartPopup';

const noTransitionTypes = [
  'lessonResume',
  'JustInTimeMotivation',
  'serieCompleta',
  'deblocarePremium',
  'clasament',
  'feedBackLesson',
  'feedbackLesson',
];

const hiddenHeaderTypes = [
  'feedBackLesson',
  'feedbackLesson',
];

const disabledElementsTypes = [
  'explanationLesson',
  'lessonCompletion',
];

const StatusProgres = ({
  width,
  onExitClick,
  coinCount,
  lessonCoinsEarned = 0,
  hideCoinsPopup = false,
  livesCount,
  lessonType,
  showCardDots = false,
  totalCards = 0,
  activeCardIndex = 0,
  onCardDotClick,
  onProgressAnimationStateChange,
  isContextShowing = false,
  disableHeaderElements = false,
}) => {
  const [progress, setProgress] =
    useState(width);

  const [
    displayedCoinCount,
    setDisplayedCoinCount,
  ] = useState(coinCount);

  const [
    isCoinAnimating,
    setIsCoinAnimating,
  ] = useState(false);

  const previousWidthRef =
    useRef(width);

  const isProgressAnimatingRef =
    useRef(false);

  const hideEntireHeader =
    hiddenHeaderTypes.includes(
      lessonType
    );

  useEffect(() => {
    if (
      noTransitionTypes.includes(
        lessonType
      )
    ) {
      isProgressAnimatingRef.current =
        false;

      setProgress(width);

      previousWidthRef.current =
        width;

      onProgressAnimationStateChange?.(
        true
      );

      return;
    }

    const widthChanged =
      previousWidthRef.current !==
      width;

    if (widthChanged) {
      isProgressAnimatingRef.current =
        true;

      onProgressAnimationStateChange?.(
        false
      );
    } else {
      isProgressAnimatingRef.current =
        false;

      onProgressAnimationStateChange?.(
        true
      );
    }

    setProgress(width);

    previousWidthRef.current =
      width;
  }, [
    width,
    lessonType,
    onProgressAnimationStateChange,
  ]);

  useEffect(() => {
    if (
      noTransitionTypes.includes(
        lessonType
      )
    ) {
      return;
    }

    setProgress(width);

    const rangeEl =
      document.querySelector(
        '.progress-bar-range'
      );

    if (!rangeEl) {
      return;
    }

    rangeEl.classList.add(
      'moving'
    );

    const timer = setTimeout(
      () => {
        rangeEl.classList.remove(
          'moving'
        );
      },
      600
    );

    return () =>
      clearTimeout(timer);
  }, [
    width,
    lessonType,
  ]);

  useEffect(() => {
    if (
      coinCount >
      displayedCoinCount
    ) {
      setIsCoinAnimating(true);

      const timer = setTimeout(
        () => {
          setIsCoinAnimating(
            false
          );

          setDisplayedCoinCount(
            coinCount
          );
        },
        300
      );

      return () =>
        clearTimeout(timer);
    }

    setDisplayedCoinCount(
      coinCount
    );
  }, [
    coinCount,
    displayedCoinCount,
  ]);

  /*
   * Pentru feedback nu randam nimic:
   * - fara X
   * - fara progres
   * - fara inimi
   * - fara monede
   * - fara puncte
   */
  if (hideEntireHeader) {
    return null;
  }

  const headerElementsDisabled =
    disabledElementsTypes.includes(
      lessonType
    ) ||
    isContextShowing ||
    disableHeaderElements;

  return (
    <div className="general-section-progress-bar">
      <div className="first-elements-header-progress-bar">
        <div className="status-progress-row">
          <button
            type="button"
            className="exit-lesson-button"
            onClick={onExitClick}
            aria-label="Inchide lectia"
          >
            <FontAwesomeIcon
              icon={faTimes}
              className="arrow-change-lesson-x"
            />
          </button>

          {!noTransitionTypes.includes(
            lessonType
          ) && (
            <div className="section-progress-bar-lesson">
              <div className="progress-bar-container">
                <div className="progress-bar-track" />

                <div
                  className="progress-bar-background"
                  style={{
                    width: `${progress}%`,
                  }}
                  onTransitionEnd={(
                    event
                  ) => {
                    if (
                      event.propertyName ===
                        'width' &&
                      isProgressAnimatingRef.current
                    ) {
                      isProgressAnimatingRef.current =
                        false;

                      onProgressAnimationStateChange?.(
                        true
                      );
                    }
                  }}
                />

                <div
                  className="progress-bar-background-line"
                  style={{
                    width: `${progress}%`,
                  }}
                />
              </div>
            </div>
          )}

          <div
            className={`tracking-elements${
              headerElementsDisabled
                ? ' disabled'
                : ''
            }`}
            aria-disabled={
              headerElementsDisabled
            }
          >
            <div className="lives-tracking">
              <HeartPopup
                livesCount={livesCount}
              />
            </div>

            {!hideCoinsPopup && (
              <div
                className={`coin-wrap ${
                  isCoinAnimating
                    ? 'bounce-animation'
                    : ''
                }`}
              >
                <CoinsPopup
                  coinCount={
                    displayedCoinCount
                  }
                  lessonCoinsEarned={
                    lessonCoinsEarned
                  }
                />
              </div>
            )}
          </div>
        </div>

        {!noTransitionTypes.includes(
          lessonType
        ) &&
          showCardDots &&
          totalCards > 1 && (
            <div
              className="progress-card-dots"
              role="tablist"
              aria-label="Navigare carduri"
            >
              {Array.from({
                length: totalCards,
              }).map((_, index) => (
                <button
                  key={index}
                  type="button"
                  className={`progress-card-dot ${
                    index ===
                    activeCardIndex
                      ? 'active'
                      : ''
                  }`}
                  onClick={() =>
                    onCardDotClick?.(
                      index
                    )
                  }
                  aria-label={`Card ${
                    index + 1
                  }`}
                  aria-selected={
                    index ===
                    activeCardIndex
                  }
                />
              ))}
            </div>
          )}
      </div>
    </div>
  );
};

export default StatusProgres;